import { createApp, nextTick } from 'vue';
import { Modal } from 'mdb-ui-kit';
import sanitizeHTML from 'sanitize-html';

import NodeToolbox from '@v/NodeToolbox.vue';
import ShareModal from '@v/ShareModal.vue';
import MarkingModal from '@v/MarkingModal.vue';

import base64 from '@js/modules/utils/base64';
import request from '@/common/request';
import utils from '@js/modules/utils/utils';

import { showShareModal, showMarkingModal } from '@js/modules/parts/share';

var sub_memory_modal;

const app = createApp({
    data: () => {
        return {
            // 画像のベースパス
            base_path: document.querySelector('meta[name="cf"]').attributes.getNamedItem('content').value,
            // 自身のノード
            node: null,
            // サブメモリー一覧
            items: null,
            // サブメモリー
            item: null,
        };
    },
    components: {
        NodeToolbox,
        MarkingModal,
        ShareModal,
    },
    methods: {
        showShareModal,
        showMarkingModal,
        sanitize(str) {
            return utils.nl2br(sanitizeHTML(str));
        },
        showSubMemoryModal(n) {
            this.item = n;
            if (!sub_memory_modal) {
                const mdl = this.$refs.sub_memory_modal;
                sub_memory_modal = new Modal(mdl);
            }
            sub_memory_modal.show();
        },
        async mark(target_id) {
            utils.loading(true);
            if (!target_id) {
                (<HTMLInputElement>document.getElementById('target_id')).value = (<HTMLInputElement>(
                    document.getElementById('node_id')
                )).value;
            } else {
                (<HTMLInputElement>document.getElementById('target_id')).value = target_id;
            }
            const data = await request.getParam('form');
            utils.loading(true, 0);
            // ブックマーク
            request
                .post('/save-memory', data)
                .then(res => {
                    const response = res.data;
                    const url = response.url;
                    window.location.href = url;
                })
                .catch(res => {
                    request.showErrorResponse(res, 'form');
                    utils.loading(false, 0);
                });
        },
    },
    mounted() {
        const node = (<HTMLInputElement>document.getElementById('node')).value;
        if (node) {
            base64.decode(node, 'UTF-8').then(res => {
                this.node = JSON.parse(res);
            });
        }

        const items = (<HTMLInputElement>document.getElementById('items')).value;
        if (items) {
            base64.decode(items, 'UTF-8').then(res => {
                this.items = JSON.parse(res);
            });
        }
    },
});
app.mount('#app');
